import { use } from "react";

import { UserContext } from "@/contexts";

type Campaign = "freetrial" | "acv" | "upgrade" | "bilanpublic" | "options";

/*
 * This hook generates the UTMs we want to add to the Hubspot URLs used to book a meeting with Carbo
 * With those params, Hubspot can pre-fill some fields of its form with the relevant info
 * The Rails equivalent helper is get_outbound_query_parameters
 */
const useOutboundQueryParams = (campaign: Campaign) => {
  const { user: userData } = use(UserContext);

  const utmParams = {
    utm_source: "produit",
    utm_medium: "in-app",
    utm_campaign: campaign,
  };

  let paramsToInclude = {
    email: userData?.email,
    company: userData?.company?.name,
  } as Record<string, string | undefined>;

  if (campaign === "freetrial") {
    paramsToInclude.message = "Demande de souscription après essai gratuit";
  }

  paramsToInclude = { ...paramsToInclude, ...utmParams };

  let params = "";

  for (const [key, value] of Object.entries(paramsToInclude)) {
    if (value) {
      if (params.length > 0) {
        params += `&${key}=${encodeURIComponent(value)}`;
      } else {
        params = `?${key}=${encodeURIComponent(value)}`;
      }
    }
  }

  return params;
};

export default useOutboundQueryParams;
